import {Component, EventEmitter, Output} from '@angular/core';
import {BaseModalComponent} from "./base_modal.component";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";


@Component({
	selector: 'prompt',
	template: `<base-modal [title]="title" [isLoading]="isLoading" [btnOkClass]="btnOkClass" [btnOkLabel]="btnOkLabel" [isBtnOkActive]="message && errors.length === 0" (onOk)="ok()">
		<ng-content></ng-content>
		<label>{{question}}</label>
		
		<input
			type="text"
			class="form-control"
			[(ngModel)]="message"
			(input)="onChange.emit($event.target.value)"
			name="name"
		>
		
		<p *ngIf="errors.length > 0">
				<ngb-alert [dismissible]="false" [type]="'danger'">
					<ul>
						<li *ngFor="let error of errors">
							{{ error }}
						</li>
					</ul>
				</ngb-alert>
			</p>
	</base-modal>`
})
export class PromptComponent extends BaseModalComponent {
	title: string;
	question: string;
	message: string = '';
	
	errors: string[] = [];
	
	@Output() onChange = new EventEmitter<string>();
	
	constructor(public activeModal: NgbActiveModal) {
		super(activeModal);
	}
	
	ok() {
		this.activeModal.close(this.message);
	}
}




